import { render, staticRenderFns } from "./payment-user-info.vue?vue&type=template&id=cb964b1e&scoped=true"
import script from "./payment-user-info.vue?vue&type=script&lang=js"
export * from "./payment-user-info.vue?vue&type=script&lang=js"
import style0 from "./payment-user-info.vue?vue&type=style&index=0&id=cb964b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb964b1e",
  null
  
)

export default component.exports